// Registers the PWA service worker (served by Rails at /service-worker, scope "/").
// Safe to call on every page: it no-ops where service workers are unsupported and only
// registers in secure contexts (https or localhost) — the dev server over plain http on a
// LAN IP would otherwise throw.
export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return
  if (!window.isSecureContext) return

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker").catch((error) => {
      console.error("Service worker registration failed:", error)
    })
  })
}
